// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'

import {
  Spinner,
  SvgIcon
} from '../../'

import { decodeBase64 } from '../../../utils'

import { AccountContext } from '../../../context'

const QUERY_WHATSAPPMESSAGES = gql`
  query($employerId: UUID!, $fromDate: DateTime!) {
    whatsappmessages(fromIdentity_Employer_Id: $employerId, direction: "outbound", status: "sent_upstream", messageType: "image", file_Filetype_Name: "Employee Payslip", createdOnOrAfter: $fromDate) {
      totalCount
      edges {
        node {
          id
          file {
            id
            asset
          }
          toIdentity {
            id
          }
        }
      }
    }
  }
`


export const PayslipsViewed = ({ payrollCycleDate, uniqueViews }) => (
  <AccountContext.Consumer>
    {({ currentAccountId: employerId }) => (
      <Query
        query={QUERY_WHATSAPPMESSAGES}
        variables={{
          employerId: decodeBase64(employerId),
          fromDate: moment.utc(payrollCycleDate).startOf('day')
        }}>

        {({ loading, error, data }) => {
          if (loading) {
            return <Spinner size='small' className='slds-is-relative' />
          }

          if (error) {
            return (
              <SvgIcon
                variant='utility'
                symbol='warning'
                colour='error'
                size='small'
                title={`Error fetching data necessary to display number of payslip views for ${moment(payrollCycleDate).format('DD MMM YYYY')}`}
              />
            )
          }

          const messagesMatchingPayrollCycleDate = data.whatsappmessages.edges.filter(({ node: message }) => (
            message.file.asset.includes(`_${moment.utc(payrollCycleDate).format('YYYYMMDD')}_`)
          ))

          const recipientIds = messagesMatchingPayrollCycleDate.map(({ node: message }) => (
            message.toIdentity.id
          ))

          if (uniqueViews) {
            return [...new Set(recipientIds)].length
          } else {
            return recipientIds.length
          }
        }}
      </Query>
    )}
  </AccountContext.Consumer>
)

PayslipsViewed.propTypes = {
  payrollCycleDate: PropTypes.string,
  uniqueViews: PropTypes.bool
}

PayslipsViewed.defaultProps = {
  uniqueViews: false
}



// WEBPACK FOOTER //
// ./src/components/messageplus/dashboard-reporting/PayslipsViewed.js